import { message, Switch } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Form,
  ModalItem,
  FormItem,
  ButtonItem,
  InputNumberItem,
  DatePickerItem,
  SelectItem,
  ErrorItem,
} from "../../../../Components/Items";

// Las fechas de un periodo se mandan como día de calendario ("YYYY-MM-DD"): el
// objeto moment se serializa a ISO en UTC y el día se corre si se captura de
// noche. El backend las ancla al mediodía UTC (Utils/fechaDia.utils).
const fechaDia = (valor) => (valor ? valor.format("YYYY-MM-DD") : null);

class AgregarPeriodo extends Component {
  formRef = React.createRef();

  state = {
    loading: false,
    visible: this.props.visible,
  };

  componentDidUpdate(prevProps) {
    if (prevProps.visible !== this.props.visible) {
      this.setState({ visible: this.props.visible });
      if (this.props.visible && this.props.tipoPeriodo) {
        const { diasDePago, diasSeptimos, diasPeriodo, posisionSeptimoDia } = this.props.tipoPeriodo;
        this.formRef.current?.setFieldsValue({
          diasDePago,
          diasSeptimos,
          diasPeriodo,
          posisionSeptimoDia: Array.isArray(posisionSeptimoDia) ? posisionSeptimoDia.map(Number) : [],
        });
      }
    }
  }

  onFinishFailed(e) {
    ErrorItem(e);
  }

  onFinish(values) {
    if (!values?.fechaInicio || !values?.fechaFin) {
      return message.info("Proporcione las fechas de inicio y fin del periodo");
    }
    this.setState({ loading: true });
    axios
      .post(
        "periodos/agregarPeriodo",
        {
          ...values,
          fechaInicio: fechaDia(values.fechaInicio),
          fechaFin: fechaDia(values.fechaFin),
          fechaPago: fechaDia(values.fechaPago),
          tipoPeriodoId: this.props.tipoPeriodoId,
          empresaId: this.props.empresaId,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success("Periodo agregado exitosamente");
          this.cerrarModal();
        } else if (res.data.success === 1) {
          message.error("No se pudo agregar el periodo");
        } else {
          message.error("Sucedió un error y no se pudo agregar el periodo");
        }
      })
      .catch(() => {
        this.setState({ loading: false });
        message.error("Error al comunicarse con el servidor");
      });
  }

  cerrarModal = () => {
    this.setState({ visible: false });
    this.props.cerrarAgregarPeriodo();
    if (this.formRef.current) {
      this.formRef.current.resetFields();
    }
  };

  render() {
    return (
      <ModalItem
        title="Agregar Periodo"
        visible={this.state.visible}
        spinning={this.state.loading}
        onCancel={this.cerrarModal}
        width={650}
      >
        <Form
          ref={this.formRef}
          name="modalAgregarPeriodo"
          layout
          bottom={
            <ButtonItem
              type="primary"
              htmlType="submit"
              style={{ display: "block", margin: "0 0 0 auto" }}
              loading={this.state.loading}
            >
              Guardar
            </ButtonItem>
          }
          onFinish={this.onFinish.bind(this)}
          onFinishFailed={this.onFinishFailed}
        >
          <FormItem name="fechaInicio" label="Fecha Inicio" required margin>
            <DatePickerItem placeholder="Selecciona la fecha de inicio" style={{ width: "100%" }} />
          </FormItem>

          <FormItem name="fechaFin" label="Fecha Fin" required margin>
            <DatePickerItem placeholder="Selecciona la fecha de fin" style={{ width: "100%" }} />
          </FormItem>

          <FormItem name="fechaPago" label="Fecha de Pago" margin>
            <DatePickerItem placeholder="Selecciona la fecha de pago" style={{ width: "100%" }} />
          </FormItem>

          <FormItem name="ejercicio" label="Ejercicio" margin>
            <InputNumberItem placeholder="Ej. 2024" min={2000} max={2100} />
          </FormItem>

          <FormItem name="mes" label="Mes" margin>
            <InputNumberItem placeholder="Ej. 1 para Enero" min={1} max={12} />
          </FormItem>

          <FormItem name="diasDePago" label="Días de Pago" margin>
            <InputNumberItem placeholder="Días de pago" min={1} />
          </FormItem>

          <FormItem name="diasSeptimos" label="Días Séptimos" margin>
            <InputNumberItem placeholder="Días séptimos" min={0} />
          </FormItem>

          <FormItem name="diasPeriodo" label="Días del Periodo" margin>
            <InputNumberItem placeholder="Días del periodo" min={1} />
          </FormItem>

          <FormItem
            name="posisionSeptimoDia"
            label="Posición Séptimo Día"
            margin
            getValueFromEvent={(vals) => vals.map(Number).filter((n) => !isNaN(n))}
          >
            <SelectItem
              mode="tags"
              placeholder="Ej. 7, 14, 21"
              tokenSeparators={[","]}
              open={false}
            />
          </FormItem>

          <FormItem name="inicioMes" label="Inicio de Mes" margin valuePropName="checked">
            <Switch />
          </FormItem>

          <FormItem name="finMes" label="Fin de Mes" margin valuePropName="checked">
            <Switch />
          </FormItem>

          <FormItem name="inicioBimestreIMSS" label="Inicio Bimestre IMSS" margin valuePropName="checked">
            <Switch />
          </FormItem>

          <FormItem name="finBimestreIMSS" label="Fin Bimestre IMSS" margin valuePropName="checked">
            <Switch />
          </FormItem>

          <FormItem name="inicioEjercicio" label="Inicio de Ejercicio" margin valuePropName="checked">
            <Switch />
          </FormItem>

          <FormItem name="finEjercicio" label="Fin de Ejercicio" margin valuePropName="checked">
            <Switch />
          </FormItem>
        </Form>
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(AgregarPeriodo);